import { ROUTE_PATHS } from "@client-shared/lib/constants";

export const DOMAIN_REGEX_PATTERNS = {
  PROTOCOL: /^http?:\/\//,
  SSL_PROTOCOL: /^https?:\/\//,
  PREFIX: /^www\./,
  SHOPIFY_ADMIN: /admin\.shopify\.com\/store\//,
  SHOPIFY_SUFFIX: /\.myshopify\.com\/?$/,
};

/**
 * Sanitizes a Shopify domain by removing protocol, prefix, admin path, and suffix.
 * Converts the domain to a clean store identifier.
 */
export const sanitizeShopifyDomain = (value: string): string => {
  if (!value) return "";
  return value
    .replace(DOMAIN_REGEX_PATTERNS.PROTOCOL, "")
    .replace(DOMAIN_REGEX_PATTERNS.SSL_PROTOCOL, "")
    .replace(DOMAIN_REGEX_PATTERNS.PREFIX, "")
    .replace(DOMAIN_REGEX_PATTERNS.SHOPIFY_ADMIN, "")
    .replace(DOMAIN_REGEX_PATTERNS.SHOPIFY_SUFFIX, "")
    .replaceAll("/", "")
    .replaceAll(/\s+/g, "-")
    .toLowerCase()
    .trim();
};

/**
 * Sanitizes a WooCommerce domain by removing the protocol prefix.
 */
export const sanitizeWooCommerceDomain = (shop: string): string => {
  return `${shop.replace(/^(https?:\/\/)?(.+)$/i, "$2")}`;
};

/**
 * Constructs the WooCommerce authorization URL for OAuth flow.
 */
export const prepareWooCommerceAuthorizeUrl = (
  domain: string,
  jwtToken: string,
  apiHost: string,
  clientHost: string
): string | undefined => {
  const storeBaseUrl = `https://${domain}`;
  const endpoint = "/wc-auth/v1/authorize";
  const callbackUrl = `${apiHost}/oauth/v1/woocommerce/install/callback`;
  const returnUrl = `${clientHost}${ROUTE_PATHS.SETTINGS}?shop=${domain}`;

  const queryString = new URLSearchParams();
  queryString.append("app_name", "Beanz Connect App");
  queryString.append("scope", "read_write");
  queryString.append("user_id", `${jwtToken}`);
  queryString.append("return_url", returnUrl);
  queryString.append("callback_url", callbackUrl);

  return storeBaseUrl + endpoint + "?" + queryString;
};
